"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import styles from '../ProgressBar.module.scss.mjs';
import 'react';
import { useNumberFormatter } from 'react-aria';
import { Legend } from '../../Legend/Legend.mjs';
import { LegendItem } from '../../Legend/components/LegendItem/LegendItem.mjs';
import { getCategoricalColorByIndex } from '../../../lib/tokens/getCategoricalColorByIndex.mjs';

const ProgressBarLegend = (props) => {
  const { segments, showLegend, formatOptions } = props;
  const formatter = useNumberFormatter(formatOptions);
  if (!segments || !showLegend) {
    return null;
  }
  return /* @__PURE__ */ jsx(Legend, { className: styles.legend, children: segments.map((s, i) => /* @__PURE__ */ jsx(
    LegendItem,
    {
      color: s.color ?? getCategoricalColorByIndex(i),
      children: `${s.title} (${s.valueText ?? (formatOptions ? formatter.format(s.value) : `${s.value} %`)})`
    }
  )) });
};

export { ProgressBarLegend };
//# sourceMappingURL=ProgressBarLegend.mjs.map
